export default __webpack_public_path__ + "static/14-afabf6613414f27697d0bee85a92c084.jpg";